import React from 'react';
import styled from 'styled-components';
import { Row, Col, Image } from 'react-bootstrap';
import Section from '../../components/Section';
import beesIllustration from '../../assets/illustrations/bees.svg';

const FloatingImage = styled(Image)`
  animation-name: floating;
  animation-duration: 3s;
  animation-iteration-count: infinite;
  animation-timing-function: cubic-bezier();


@keyframes floating {
    from { transform: translate(0,  0px); }
    65%  { transform: translate(0, 10px); }
    to   { transform: translate(0, -0px); }   
  } 
`;

const Text = styled.span`
  font-weight: 600;
  opacity: 0.8;
`;

const Loading = () => {
  return (
    <Section>
      <Row className="mb-5 d-flex justify-content-center">
        <Col md={3} className="d-flex justify-content-center">
          <FloatingImage src={beesIllustration} alt="Illustration bees" fluid />
        </Col>
      </Row>
      <Row className="d-flex justify-content-center text-center">
        <Col>
          <Text>
            Onze modellen zijn aan het rekenen...
          </Text>
        </Col>
      </Row>
    </Section>
  );
}

export default Loading;
